export default __webpack_public_path__ + "04bfefdff86e39017f4a097ba1d2fe48.png";